// extracted by mini-css-extract-plugin
export default {"link":"navbar-auth_link__g0h4h"};